// Covers direct fetch callers as well as apiRequest (uploads and automatic
// mark-read requests often don't surface their own errors).
export function observeImpersonationReadOnly(
  target: Pick<Window, "fetch">,
  notify: (message: string) => void,
) {
  const originalFetch = target.fetch;
  const observedFetch: typeof fetch = async (...args) => {
    const response = await originalFetch.apply(target, args);
    if (response.status === 403) {
      const body = await response.clone().json().catch(() => null);
      if (body?.impersonationReadOnly && typeof body.message === "string") {
        notify(body.message);
      }
    }
    return response;
  };
  target.fetch = observedFetch;
  return () => {
    if (target.fetch === observedFetch) target.fetch = originalFetch;
  };
}
